import { useCallback, useEffect, useState } from 'react';

import { ActionCenterItemV2 } from '@cloudcost/shared-types/action-center-v2';

import { ActionCenterModule, fetchActionCenterItemV2 } from '@/utils/actionCenterDetails';

export function useActionItemDetails(
  module: ActionCenterModule,
  id?: string | null,
  items?: ActionCenterItemV2[],
) {
  const [item, setItem] = useState<ActionCenterItemV2 | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const found = await fetchActionCenterItemV2(module, id, items);
      setItem(found);
    } catch (e: any) {
      setError(e?.message || 'Failed to fetch action item');
    } finally {
      setLoading(false);
    }
  }, [module, id, items]);

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id, refetch]);

  return { item, loading, error, refetch };
}
